"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Container zur Verwaltung der featurebasierten Abfrage-Ergebnisse pro Layer innerhalb eines Popup.
 *
 * @class
 * @extends gc.gis.module.GCFeatureInfo.AbstractFeatureResultList
 * @memberof gc.gis.module.GCFeatureInfo
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.module.GCFeatureInfo.FeatureResultListPopup = function()
{
    gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.call(this);

    /**
     * Container für das Accordion der Features
     * @type {gc.gis.widget.GCAccordion}
     * @private
     */
    this._feature_container = null;
	/**
	 * FE-Flag.
	 * @type {boolean}
	 */
	this.fe = gc.gis.iface.fe;

    // Elemente erzeugen und Hauptcontainer initialisieren
    this._render();
};
gc.gis.module.GCFeatureInfo.FeatureResultListPopup.prototype = Object.create(gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype);

/**
 * @inheritDoc
 */
gc.gis.module.GCFeatureInfo.FeatureResultListPopup.prototype._render = function()
{
    this._feature_container = new gc.gis.widget.GCAccordion({
        className: this.className
    });

    return this._feature_container.getElement();
};

/**
 * @inheritDoc
 */
gc.gis.module.GCFeatureInfo.FeatureResultListPopup.prototype.setFeatureDetail = function (layer, feature, content, contentType)
{
    const index = this.getFeatureIndex(feature);
    const inIframe = contentType === gc.gis.module.GCFeatureInfoDetailResultTypes.HTML
        || contentType === gc.gis.module.GCFeatureInfoDetailResultTypes.HTML_THIRD_PARTY;
    const sandboxIframe = contentType === gc.gis.module.GCFeatureInfoDetailResultTypes.HTML_THIRD_PARTY;

    if (index >= 0)
    {
        if (!(content instanceof jQuery))
        {
            if (inIframe)
            {
                const content2 = content;
                let element;
                if (sandboxIframe)
                {
                    element = jQuery('<iframe style="width: 100%; height: 500px;" src="' + content + '" sandbox>');
                }
                else
                {
                    element = jQuery('<iframe style="width: 100%; height: 500px;">');
                    element.on('load', function (evt) {
                        // content nur beim ersten Laden des iFrames setzen, dann nicht mehr (z.B. wenn Link innerhalb des iFrame geklickt wird)
                        const childs = jQuery(this).contents().find('body').children();
                        if (0 === childs.length)
                        {
                            this.contentDocument.open();
                            this.contentDocument.write(content2);
                            this.contentDocument.close();
                        }
                    });
                }
                content = element;
            }
        }

        this._feature_container.setItemContent(index, content);
    }
};

/**
 * @inheritDoc
 */
gc.gis.module.GCFeatureInfo.FeatureResultListPopup.prototype._createFeatureItem = function (layer, feature)
{
    const self = this;

	// Aktionen
    const btn_group = new gc.gis.widget.GCWidgetGroup({
		containerClassName: 'gc-feature-actiongroup'
	});

    const item = this._feature_container.addItem(
        'feature_' + feature.getAttribute('featureLayer') + '_' + feature.getID(),
        feature.getAttribute('title') || 'Objekt',
        '',     // TODO ggf. Ladeanimation per Default einblenden
        {
            open: function(index, evt) {
                self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_OPEN, {
                    layer: layer,
                    feature: feature
                });
            },
            close: function(index, evt) {
                self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_CLOSE, {
                    layer: layer,
                    feature: feature
                });
            },
            enter: function(index, evt) {
                self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_MOUSEENTER, {
                    layer: layer,
                    feature: feature
                });
            },
            leave: function(index, evt) {
                self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_MOUSELEAVE, {
                    layer: layer,
                    feature: feature
                });
            }
        }
    );

	// im Frontendmodus nur den Zoombutton anzeigen, dort gibt es bislang keine weiteren Aktionen
	if (!this.fe)
	{
        const action_menu = new gc.gis.widget.GCMenu({
			label: 'Aktionen',
			className: 'gc-feature-action',
			direction: 'right',
			icon: 'glyphicon glyphicon-option-vertical',
			containerClassName: 'gc-feature-actionmenu'
		});
		btn_group.addItem(action_menu);

		// Standardaktionen
		action_menu.addItem(new gc.gis.widget.GCItem({
			label: 'Zum Objekt zoomen',
			click: function(evt) {
				self._doFeatureZoom(layer, feature);
			}
		}));

		// featurespezifische Aktionen
        const featureActions = feature.getAttribute('actions');
        let btn_action;
		for (let i=0; i<featureActions.length; i++)
		{
			btn_action = new gc.gis.widget.GCItem({
				label: featureActions[i].caption,
				action: gc.gis.action.GCServerSideActionFactory.createAction(featureActions[i])
			});
			action_menu.addItem(btn_action);
		}
	}
	else
	{
		// Zoom-Button
		if (feature.getGeometry())
		{
			const btn_zoom = new gc.gis.widget.GCItem({
				label: 'Zum Objekt zoomen',
				className: 'gc-feature-action',
				icon: 'ms ms-zoom-to-extent',
				click: function (evt) {
					self._doFeatureZoom(layer, feature);
				}
			});

			btn_group.addItem(btn_zoom);
		}
	}

	// Button in die Kopfleiste zum Feature einklinken
    if (btn_group.numItems() > 0)
    {
        const head = item.children('.panel-heading');
	    head.append(btn_group.getElement());
    }

    // ggf. fertigen Detail-Content setzen
    const result = feature.getAttribute('detailResult');
    if (result !== undefined && result !== null)
    {
        this.setFeatureDetail(layer, feature, result.content, result.contentType);
    }

    // ersten Eintrag öffnen (ggf. über Event gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_ADD am Modul erledigen)
    if (1 === this.numFeatures())
    {
        this._feature_container.openItem(0);
    }

    return item;
};